import { useIsFetching } from '@tanstack/react-query';
import { ReactComponent as CompetitorDatabaseSvg } from 'assets/svg/Competitor-Database.svg';
import { ReactComponent as CompetitorSwappedSvg } from 'assets/svg/Competitor-Swapped.svg';
import { ReactComponent as PlusSvg } from 'assets/svg/Plus.svg';
import { AddManualCompetitorModal, SelectAddWayModal, UploadBulkCompetitorModal } from 'components/Modals';
import { HelloMuiButton } from 'components/Mui';
import { useCallback, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import useCompetitorsStore from 'store/useCompetitorsStore';
import useUserStore from 'store/useUserStore';
import { MAX_LIMIT } from 'util/Constants';

const HeaderSection = () => {
    const { getUserPlan, userInfo } = useUserStore();
    const plan = getUserPlan();

    const [showChoiceModal, setShowChoiceModal] = useState<boolean>(false);
    const [showOneByOne, setShowOneByOne] = useState<boolean>(false);
    const [showBulkUpload, setShowBulkUpload] = useState<boolean>(false);

    const { totalCount } = useCompetitorsStore();

    const isFetchingCompetitors = useIsFetching({
        queryKey: ['fetchAllCompetitors'],
    });

    const onChoiceClicked = useCallback(() => {
        setShowChoiceModal(true);
    }, []);

    const onAddOneByOneClicked = () => {
        setShowOneByOne(true);
        setShowChoiceModal(false);
    };

    const onBulkUpload = () => {
        setShowBulkUpload(true);
        setShowChoiceModal(false);
    };

    return (
        <>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 md:gap-[16px] gap-[10px] px-[20px] py-[8px] bg-my-gray bg-opacity-40">
                <div className="rounded-[5px] h-[48px] flex justify-between py-[10px] px-[12px] bg-white border border-my-gray">
                    <div>
                        {isFetchingCompetitors ? (
                            <Skeleton className="h-full w-28" />
                        ) : (
                            <>
                                <div className="text-[10px]">Collaboration Partner Database</div>
                                <div className="font-medium">{totalCount}</div>
                            </>
                        )}
                    </div>
                    <CompetitorDatabaseSvg />
                </div>

                <div className="rounded-[5px] h-[48px] flex justify-between py-[10px] px-[12px] bg-white border border-my-gray">
                    <div>
                        <div className="text-[10px]">{'Can be swapped this month'}</div>
                        <div className="font-medium">
                            {plan.maxSwapCount === MAX_LIMIT ? 'Unlimited' : plan.maxSwapCount - userInfo?.swapsThisMonth!}/
                            {plan.maxSwapCount === MAX_LIMIT ? 'Unlimited' : plan.maxSwapCount}
                        </div>
                    </div>
                    <CompetitorSwappedSvg />
                </div>

                <HelloMuiButton variant="outlined" onClick={onChoiceClicked}>
                    <div className="text-my-blue flex items-center gap-[4px]" data-cy="add-manual-competitor">
                        <PlusSvg />
                        <span>{`Add Missing Collaboration Partner`}</span>
                    </div>
                </HelloMuiButton>
            </div>

            <SelectAddWayModal
                visible={showChoiceModal}
                onClose={() => setShowChoiceModal(false)}
                onAddOneByOneClicked={onAddOneByOneClicked}
                onBulkUpload={onBulkUpload}
            />
            <AddManualCompetitorModal visible={showOneByOne} onClose={() => setShowOneByOne(false)} />
            <UploadBulkCompetitorModal visible={showBulkUpload} onClose={() => setShowBulkUpload(false)} />
        </>
    );
};

export default HeaderSection;
